module.exports = __webpack_public_path__ + "media/images/recipe-form-placeholder-9070a28e.webp";